module.exports = __webpack_public_path__ + "static/bloombrasLogo-388c1e5c6b4930013a8a42e08c3a831c.png";